import {useQuery, gql} from '@apollo/client'

export const GET_AUDIT_DETAILS = gql`
  query GetAuditDetails($fetchType: String!, $page: Int!, $pageSize: Int!) {
    getAuditDetails(fetchType: $fetchType, page: $page, pageSize: $pageSize) {
      page
      pageSize
      totalCount
      projects {
        EVENT_TYPE
        CLIENT_ID
        CLIENT_NAME
        GROUP_ID
        GROUP_NAME
        PROPERTY
        CHANGED_DATA
        CHANGED_BY
        USER_ROLE
        AUDITED_AT
        SNAPSHOT
      }
    }
  }
`

export function useAuditDetails({fetchType, page, pageSize, skip = false}) {
  const {
    data: auditDetailsData,
    loading: loadingAuditDetails,
    error: errorAuditDetails,
    refetch: refetchAuditDetails
  } = useQuery(GET_AUDIT_DETAILS, {
    context: {clientName: 'adminPanel'},
    variables: {fetchType, page, pageSize},
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip
  })

  return {auditDetailsData, loadingAuditDetails, errorAuditDetails, refetchAuditDetails}
}
